import API from "./../../../utils/api";

export const getPartnerDurationApi = async (filters) => {
  const response = await API.get("settings/payment-duration", { params: filters });
  return { response };
};

export const addPartnerDurationApi = async (data) => {
  const response = await API.post("settings/payment-duration", data);
  return { response };
};

export const updatePartnerDurationApi = async (data, id) => {
  const response = await API.put(`settings/payment-duration/${id}`, data);
  return { response };
};

export const deletePartnerDurationApi = async (id) => {
  const response = await API.delete(`settings/payment-duration/${id}`);
  return { response };
};
